/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * English (UK): en-gb
 */

/**
 * Translation file for en-GB locale
 *
 * @file en-gb.js
 * @author Mohamed yasar arabath M
 */

const engb = {
  'popularChannelSlider.allChannels': 'All Channels',
  'popularChannelSlider.recommended': 'Recommended',
  'hero.myetextbook.link': 'library',
  'hero.myetextbook.text': 'Not the right title? Access your eTextbook',
  'hero.etextfeaturestitle': 'Find study materials in your eTextbook',
  'hero.etextfeaturesdescription': 'Your eTextbook comes with study materials designed to help you succeed. Study with flashcards and more right in your eTexbook.',
  'aichat.title1': 'Get AI-powered help for anything related to this eTextbook.',
  'aichat.chatDesc1': 'Type a question to start',
  'subscriptiontext.isSubscribed': 'Part of your subscription',
  'subscriptiontext.nonSubscriber': 'Upgrade for full access',
  'topicConatiner.otherHeader': 'Related videos and practice',
  'topicConatiner.exactLiteHeader': 'Related concepts and practice',
  'moremenu.downloadApp': 'Download the app',
  'moremenu.downloadAppAlreadyDownload': '%Click here% to download the app on another device and automatically sign in or to use your unique QR code to securely sign in on the app you\'ve already installed.',
  'moremenu.downloadAppNotDownload': '%Click here% to download the app and securely sign in with your unique QR code.',
  'channel.noBundletitle': 'Use Study Prep for your related & other courses',
  'onboard.studyPlan': 'Custom study plan created!',
  'onboard.addCourseAnother': 'Do you want to add another course?',
  'onboard.purchase': 'I need to purchase a Pearson eTextbook',
  'onboard.addCourseWithoutEtext': 'Add course using Study Prep',
  'onboard.mayBeLater': 'Maybe later',
  'onboard.aboutCourse': 'Tell us about your course',
  'onboard.close': 'Close',
  'course.addTitle': 'Add course',
  'common.PURCHASE': 'Purchase',
  'common.CLOSE': 'Close',
  'open': 'Open',
  'continue': 'Continue',
  'yes': 'Yes',
  'no': 'No',
  'audio': 'Audio',
  'courses.toc.PUBLISH_SUCCESS': 'Success!',
  'courses.toc.PUBLISH_MESSAGE': 'Students will see your changes the next time they open content.',
  'errors.GENERIC_TITLE': 'You don\'t have access right now',
  'errors.GENERIC_DESC': 'First, refresh or clear your cache. If that doesn’t work, contact Pearson ',
  'errors.GENERIC_LINK': 'support.',
  'errors.GENERIC_CODE': 'Error code: {code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'Subscription Not Found',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'Your account does not include access to this title. If you think you have received this message in error please contact Pearson Technical Support',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'Subscription Not Found',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'Your subscription does not include access to the eTextbook, but you can subscribe to it straight away using a credit card.',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/higher-education/products-services-teaching/course-content/textbooks-and-etexts/pearson-etext/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'My account',
  'menu.helpCenter': 'Help centre',
  'menu.preferencesCenter': 'Preferences center',
  'menu.CONTACT_SUPPORT': 'Contact Support',
  'menu.HELP_SUPPORT': 'Help & support',
  'menu.FAQS': 'FAQs',
  'menu.CHAT_WITH_SUPPORT': 'Chat with support',
  'menu.OTP_CODES': 'OTP codes',
  'menu.LAUNCH_CODE': 'Launch code log',
  'menu.SEND_CODE': 'Send user new code via email',
  'menu.SEND_CODE_PHONE': 'Send user new code via text message',
  'menu.LEGAL': 'Legal',
  'menu.PRIVACY_NOTICE': 'Privacy notice',
  'menu.TITLE_INFO': 'Title info',
  'menu.PEARSON_ACCESSIBILITY': 'Pearson accessibility',
  'menu.DEVICE_WARNING_MESSAGE': 'Register {deviceLimit} devices. Swap one per month.',
  'menu.ACCESSIBILITY': 'Accessibility',
  'menu.ACCESSIBILITY_SUPPORT': 'Accessibility support',
  'menu.DEVICES': 'Recent devices',
  'menu.THIS_DEVICE': 'This Device',
  'menu.GET_THE_APP_DOWNLOAD': 'Download the Mobile app',
  'menu.MOJO_APP_INFO': 'Head to the app store on your phone or tablet to use Pearson+ offline.',
  'menu.DEVICE_LABEL': 'Device',
  'menu.DEVICE_DISCONNECT': 'Disconnect',
  'menu.FOXIT': 'Powered by FoxIT',
  'menu.TERMS_OF_USE': 'Terms of use',
  'menu.SIGN_OUT': 'Sign out',
  'menu.PRINT_PAGE': 'Print page',
  'menu.COPY_RIGHT': 'Copyright © {year} Pearson Education Inc. All Rights Reserved.',
  'print.FOOTER_MESSAGE': 'Printed by {fullName} ({email}) on {currentDate}.',
  'print.WATERMARK': 'Copyright © {year} Pearson Education',
  'device.SWAPPED_ALREADY': 'You\'ve already swapped this month',
  'device.SWITCH_DEVICE': 'Switch to current device?',
  'device.SWITCH_ONCE': 'Since you can only switch once a month, you won\'t be able to undo this.',
  'device.SEAT_TAKEN': 'That seat’s taken',
  'device.DISCONNECT_DEVICE': 'You can only log in on 3 devices. To continue here, disconnect another device.',
  'device.ALERT_TEXT': 'Remember, you can only swap devices once a month.',
  'device.DISCONNECT': 'Disconnect',
  'device.CONTINUE': 'Continue',
  'device.HEADER': 'End your other browser session?',
  'device.CLOSE': 'Back to home',
  'device.CODE': 'Continue here by entering the authentication code we sent to {maskedEmail}. Not working? Check your spam folder, {email}, or contact {support}.',
  'device.TIMER': 'You have {time} to enter your code here',
  'device.RESEND': '{resend}',
  'device.FAQ': 'FAQ',
  'device.RESEND_NAME': 'Resend',
  'device.NOTE': 'If you regularly use Pearson+ in two places, such as at work and at home, make sure you log out when you’re finished. You can also use the Pearson+ mobile app on up to two devices. For more info, see our {faq}.',
  'device.NOTE_HEADER': 'Avoid this next time',
  'device.CONTACT_SUPPORT': 'customer support',
  'device.CONTACT_EMAIL': 'update your email',
  'device.INCORRECT': 'Incorrect—double check your code or resend it.',
  'device.MANY_ATTEMPTS': 'Too many attempts, try resending the code',
  'device.EXPIRED': 'Your time expired, try resending the code',
  'device.ACCESS_HEADER': 'You’re in!',
  'device.ACCESS_DESC': 'Your session has been authenticated. Want to update your password while you’re at it?',
  'device.ACCESS_CHANGE_PASSWORD': 'Change password',
  'device.ACCESS_RESET_PASSWORD': 'Reset password',
  'device.THREATONE_TITLE': 'Is everything okay?',
  'device.THREATONE_DESC': 'We have noticed some suspicious activity on your account.',
  'device.THREATONE_DESC_TWO': 'We recommend changing your password.',
  'device.MAY_BE_LATER': 'Maybe later',
  'device.OKAY': 'Okay',
  'device.ACCOUNT_LOCK_DESC': 'To keep it secure, we\'re logging you out. We\'ve sent a password reset link to the email associated with your account.',
  'device.ACCOUNT_LOCK_TITLE': 'We’ve noticed some fishy activity on your account',
  'device.ACCOUNT_LOCK_TIMER': 'You\'ll be logged out in {time}',
  'navigation.PAGE': 'Page',
  'launchcode.CREATEBY': 'Created by:',
  'launchcode.sentvia': 'Sent via:',
  'launchcode.CODEINLAST': 'Codes in the last 7 days:',
  'launchcode.TIMESENT': 'Time sent: ',
  'launchcode.ACCOUNTEMAIL': 'Account email:',
  'launchcode.LAUNCHDIALOGTITLE': 'OTP Code Log',
  'textmessage.TITLE': 'Enter Phone Number',
  'textmessage.PHONE_NUMBER': 'Phone Number',
  'textmessage.SEND_CODE': 'Send Code',
  'textmessage.INVALID_NUMBER': 'Invalid Phone Number',
  'textmessage.SUCCESS_MESSAGE': 'Code sent',
  'remove.title': 'Remove title?',
  'remove.subTitle': 'You can always get it back later—just use search to add it again.',
  'remove.buttonText': 'Remove',
  'search.searchPlaceHolderPPlus': 'Search by ISBN, Title, or Author',
  'search.searchPlaceHolderEText': 'Search your library',
  'footer.downloadMobileApp': 'Download the Mobile app',
  'footer.termsOfUse': 'Terms of use',
  'footer.privacy': 'Privacy',
  'footer.cookies': 'Cookies',
  'footer.doNotSellMyPersonalInformation': 'Do not sell my personal information',
  'footer.accessibility': 'Accessibility',
  'footer.patentNotice': 'Patent notice',
  'footer.copyrights': 'Pearson All rights reserved.',
  'hero.toc.defaultPlacehoder': '--- select a topic ---',
  'hero.openEtextBookV1': 'Open eTextbook',
  'hero.heroHeading': 'Because you\'re studying <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': 'Study Prep',
  'hero.study.help': 'Get study help',
  'hero.study.jumpBackIn': 'Jump back in',
  'hero.study.numOfUsers': 'Currently there are <b>{num_of_users}</b> students using Channels.',
  'hero.heroChannel.cardsHeading': 'Continue from where you left off',
  'hero.marketingcard1.copy.title': 'Learn with videos',
  'hero.marketingcard1.copy.description': 'Watch bite-size video explanations that break down tricky topics.',
  'hero.marketingcard2.copy.title': 'Practice problems',
  'hero.marketingcard2.copy.description': 'Prep for your exam with thousands of exam-like questions and video solutions.',
  'hero.marketingcard3.copy.title': 'Get expert help',
  'hero.marketingcard3.copy.description': 'Post questions and get answers from subject matter experts.',
  'hero.popularTopics.heading': 'Other popular topics in this Channel',
  'hero.popularChannels.headingv1': 'Taking another course?',
  'hero.popularChannels.descriptionv2': 'Browse popular study help topics.',
  'hero.practice': 'Practise',
  'hero.herobook.mappedChannelHeading': 'Recommended study help in this Channel',
  'libraryL2.myBooks': 'My Books',
  'libraryL2.archived': 'Archived',
  'libraryL2.back': 'Back',
  'hero.practiceProblem': 'Practice Problem',
  'nativeAppBanner.drawer.title': 'Open in...',
  'nativeAppBanner.drawer.pearsonApp': 'Pearson+ App',
  'nativeAppBanner.banner.title': 'Pearson+ app',
  'nativeAppBanner.banner.description': 'Learn on the go',
  'hero.promotionalcard.list1': 'Bite-size videos that break down tricky topics',
  'hero.promotionalcard.list2': 'Thousands of exam-style questions',
  'hero.promotionalcard.list3': 'Get answers from subject matter experts',
  'hero.studyandexamprep': 'Study Prep',
  'hero.heroBook.sectionSubHeadingV1': 'Break down tough topics with video explanations and practice questions tailored to your course.',
  'hero.heroBook.sectionSubHeadingV2': 'Break down tough topics with concept explanations and practice questions tailored to your course.',
  'hero.SeeAllStudyOptions': 'See all study options',
  'hero.herobook.mappedChannelHeadingV1': 'Recommended videos and practice questions',
  'hero.popularTopics.headingV1': 'Other popular topics',
  'hero.heroHeadingV1': 'For <span>{replace_value}</span>',
  'hero.learnmore': 'Learn more',
  'hero.eTextbook': 'eTextbook',
  'hero.goToPage.label': 'Go to page',
  'subscription.studyTitle': 'Study Prep',
  'print.printAvailTitle': 'Want to print this page? Here’s how',
  'print.printAvailDesc': 'In your eTexbook, select the account icon in the top right. From the options, choose “Print page” and then choose your print settings.',
  'print.printNotAvailTitle': 'The print option for this eText is disabled.',
  'print.printNotAvailDesc': 'For convenient offline access, please download your title through the Pearson+ mobile app and enjoy the flexibility of studying anytime, anywhere!',
  'hero.header.cta': 'Go to study tools',
  'hero.header.ctav2': 'Open Study Prep',
  'hero.marketing.title': 'Find your eTextbook',
  'hero.marketing.subTitle': 'Choose from over 2,000 eTextbooks with audio, flashcards, notes, and more. Only $10.99/mo for a 4-month term.',
  'hero.popularchannels.desc': 'Get study help with these top subjects',
  'hero.removecourse.title': 'Remove course from dashboard?',
  'hero.removecourse.description': 'You can always add this course back to your dashboard by clicking "Add course".',
  'hero.removecourse.primaryCtaText': 'Remove',
  'hero.removecourse.secondaryCtaText': 'Cancel',
  'hero.tableOfContents': 'Table of contents',
  'hero.search': 'Search',
  'hero.emptystate.cta': 'Search eTextbooks',
  'hero.watch_it_again': 'Watch it again',
  'hero.mondly.learnLang.title': 'Learn a new language for free',
  'hero.mondly.subTitle': 'Pearson eTextbook users get three free months of Mondly by Pearson.',
  'hero.mondly.description': 'Most language learning apps only let you learn from English, but it\'s best to learn from your native language. Mondly therefore allows you to learn from any of our <strong>41 languages</strong>.',
  'hero.mondly.startLearningCTA': 'Start Learning',
  'hero.mondly.marketing.bestApp': 'Best App',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': 'App of the Year',
  'hero.mondly.marketing.fbStart': 'Facebook FbStart - 2017 EMEA Winner',
  'hero.mondly.marketing.editorChoice': 'Editor’s Choice',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'Learn a Language',
  'header.menu.moreAtPearson': 'More at Pearson',
  'hero.subscriptionStatusTitle2': 'Your Pearson+ resources',
  'hero.startStudying': 'Start studying',
  'onboard.studyMaterials': 'Choose your subject and we\'ll create a dashboard with customised study materials.',
  'hero.myETextbooks': 'My eTextbooks',
  'header.continueInTheApp': 'Continue in the app',
  'hero.learnTxt': 'Learn',
  'hero.examPrepTxt': 'Exam prep',
  'hero.aITutorTxt': 'AI Tutor',
  'AI.toolTip': 'Ask me about anything in your eTextbook',
  'hero.studyExamPrepAllYourCourses': 'Study Prep for all your courses',
  'header.qrCode.subHeaderTxt': 'Use this QR code to quickly and securely sign in to the Pearson+ app on your mobile device.',
  'header.qrCode.dontHaveApp': 'Don\'t have the app?',
  'header.qrCode.footerTxt': 'Scanning this code will redirect you to the App Store or Google Play. Once you have downloaded the app, sign in by scanning it again.',
  'header.qrCode.errorMsg': 'The QR code didn\'t load. Close and try again.',
  'hero.yourETextbook': 'Your eTextbook',
  'onboard.addCourseWithEtextBundle': 'Add course using Study Prep',
  'onboard.disableTooltipText': 'All Study Prep courses are added!',
  'subscriptionstatus.bundlecta': 'Access Study Prep',
  'subscriptionstatus.nonbundlecta': 'Access Study Prep',
  'channel.genericBundle': 'Use your Study Prep for help in your other courses',
  'channel.relatedBundle': 'Also use your Study Prep for help in your other courses',
  'onboard.courseAdded': 'Course added!',
  'hero.flashcards': 'Flashcards',
  'relatedChannelCard.title': 'Enhance your learning with this related resource',
  'relatedChannelCard.badgeText': 'Related Study Prep',
  'sessionInactivity.title': 'Are you still there?',
  'sessionInactivity.description': 'Your session will time out in <b>%TIMER%</b> due to inactivity.<br/> Would you like to stay signed in?',
  'sessionInactivity.keepMeSignIn': 'Keep me signed in',
  'sessionInactivity.signOut': 'Sign Out',
  'sessionTimeout.title': 'Session timed out',
  'sessionTimeout.description': 'Your session has timed out due to inactivity.',
  'print.qrCode.header': 'Use this QR code to open the Pearson+ app on your mobile device.',
  'print.qrCode.footer': 'Scanning this code will redirect you to the App store or Google Play. Once the app is installed, sign in to download and access your title.',
  'hero.nestest.title': 'Prepare for your teacher certification exam',
  'hero.nestest.subTitle': 'Pearson+ users can now access nationally aligned preparation courses and practice tests to prepare for their teacher certification exams.',
  'hero.channelAI.title': 'Need help? AI Tutor has you covered.',
  'hero.channelAI.desc': 'Ask a question and get step-by-step homework help, study recommendations, and more — personalised help whenever you need it.',
  'hero.channelAI.action': 'Ask AI Tutor Now',
  'new': 'New!',
  'hero.practice.numOfUsers': 'This section has <b>{practice_num_of_users}</b> practice problems.',
  'hero.practice.cta': 'Practice now',
  'hero.practice.title': 'Practice problem',
  'diagnostics.errorMsg': 'Diagnostics didn\'t load. Close and try again',
  'qrcode.title': 'Start studying anywhere',
  'qrcode.subtitle': 'Learn anywhere, anytime with the Pearson+ mobile app. Download now and unlock a seamless learning experience.',
  'qrcode.detailsv1': 'With the Pearson+ app, you can use this QR code to pick up where you left off. Search your book, study with flashcards, watch video lessons and more, wherever you go.',
  'qrcode.detailsv2': 'Scan this QR code whenever you want to log in quickly and pick up right where you left off.',
  'qrcode.details': 'With the Pearson+ app, you can use this QR code to pick up where you left off.',
  'qrcode.appstore': 'on the App Store',
  'qrcode.playstore': 'on Google Play',
  'nativePromoBanner.description': 'Learn anywhere, anytime with the Pearson+ mobile app. Download now and unlock a seamless learning experience.',
  'install': 'Install',
  'header.menu.createCourse': 'New course',
  'header.dropdown.courses': 'Courses',
  'header.dropdown.recentlyViewed': 'Recently viewed',
  'header.dropdown.viewAll': 'View all courses',
  'aet.courseHeader.inviteStudents': 'Invite students',
  'aet.courseHeader.inviteStudentModal.subTitle': 'Invite students to access this eTextbook by copying the link address or instructions below into your email or syllabus.',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'Link address',
  'aet.courseHeader.inviteStudentModal.copyLink': 'Copy link',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'Instructions with link address',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'Copy instructions',
  'aet.courseHeader.inviteStudentModal.instructionIntro': 'It\'s time to access {bookTitle} the eTextbook for {courseName}.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'When you\'re ready, access your eTextbook at: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'You\'ll be asked to sign in with your existing Pearson account. If you don\'t have a Pearson account, you\'ll be able to create one.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionHelp': 'Need help? ',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'Start date:',
  'aet.courseHeader.endDate': 'End date:',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'Format:',
  'aet.home.manageroster': 'Manage student list',
  'aet.home.managegradesync': 'Manage grade sync',
  'aet.home.copycourse': 'Copy course',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.instructorCourse.tabs.current': 'Current',
  'aet.instructorCourse.tabs.past': 'Past',
  'aet.instructorCourse.tabs.courseSettings': 'Course settings',
  'aet.instructorCourse.tabs.manageRoster': 'Manage student list',
  'aet.instructorCourse.currentCourses.title': 'Current courses',
  'aet.instructorCourse.pastCourses.title': 'Past courses',
  'aet.instructorCourse.createOrCopy.title': 'Create or copy course',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'Copy another instructor\'s course or create a new one',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'Copy another instructor\'s course',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'Enter the course ID to find the course you want to copy.',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'Course ID',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'Enter course ID',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'You searched for ',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'Create new course from the catalogue',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'Search by title, author, ISBN, or subject keywords.',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'Search...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'Show more',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'Show less',
  'aet.instructorCourse.cancel': 'Cancel',
  'aet.instructorCourse.loading': 'Loading...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'Grade sync',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'Manage grade sync',
  'aet.instructorCourse.courseForm.courseNameLabel': 'Course name',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'Untitled',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'Section name',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'Untitled',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'Institution',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'Institution is required',
  'aet.instructorCourse.courseForm.institutionSearchError': 'Something went wrong. Please try again.',
  'aet.instructorCourse.courseForm.institutionNoResults': 'No results found',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another Institution',
  'aet.instructorCourse.courseForm.startDateLabel': 'Course start date',
  'aet.instructorCourse.courseForm.endDateLabel': 'Course end date',
  'aet.instructorCourse.courseForm.datePlaceholder': 'dd/mm/yy',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'Allow others to copy this course',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'Share this code with instructors who want to copy this course',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'Copy code',
  'aet.instructorCourse.courseForm.optionalSuffix': '(optional)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'Form has validation errors',
  'aet.instructorCourse.courseForm.submitContinue': 'Continue',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'Saving...',
  'aet.instructorCourse.courseForm.submitError': 'Your course could not be created. Please try again.',
  'aet.instructorCourse.courseForm.submitEditError': 'Your changes could not be saved. Please try again.',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'Save changes',
  'aet.instructorCourse.courseForm.materialsHeader': 'Course materials',
  'aet.instructorCourse.courseForm.resolveError': 'Course materials could not be loaded. Please try again.',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'Last viewed',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'Recently added',
  'aet.instructorCourse.coursesSort.aToZ': 'A to Z',
  'aet.instructorCourse.coursesSort.zToA': 'Z to A',
  'aet.instructorCourse.manageRoster.column.name': 'Name',
  'aet.instructorCourse.manageRoster.column.role': 'Role',
  'aet.instructorCourse.manageRoster.column.email': 'Email',
  'aet.instructorCourse.manageRoster.column.status': 'Status',
  'aet.instructorCourse.manageRoster.enrolledDate': 'Enrolled {date}',
  'aet.instructorCourse.manageRoster.notAvailable': '--',
  'aet.instructorCourse.roster.role.student': 'Student',
  'aet.instructorCourse.roster.role.ta': 'TA',
  'aet.instructorCourse.roster.role.instructor': 'Instructor',
  'aet.instructorCourse.roster.status.active': 'Active',
  'aet.instructorCourse.roster.status.inactive': 'Inactive',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'All members',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'Active students',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'Inactive students',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'Teaching assistant',
  'aet.instructorCourse.manageRoster.filter.instructor': 'Instructor',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'Author:',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN:',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'Course creation date:',
  'aet.instructorCourse.noCoursesFound': 'No courses found',
  'aet.instructorCourse.backButton': 'Back',
  'aet.instructorCourse.selectCourse': 'Select course',
  'aet.home.linkedToLms': 'Linked to LMS',
  'aet.instructorCourse.courseForm.title.create': 'Create course',
  'aet.instructorCourse.courseForm.title.copy': 'Copy course',
  'aet.instructorCourse.courseForm.title.edit': 'Course information',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.title': 'Assignments',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.content': 'Assignment content',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.dueDates': 'Assignment due dates',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.title': 'Highlights and notes',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.highlightColor': 'Highlight colour',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.noteText': 'Note text',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.sharedStatus': 'Shared status',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.title': 'Student list and engagement',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.studentNames': 'Student names',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.emailAddresses': 'Email addresses',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.enrollments': 'Enrolments',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.completionAndInsights': 'Completion and insights',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'Settings',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.aiToolEnablement': 'AI Tool enablement',
  'aet.instructorCourse.courseForm.copyAccordionTitle': 'Show what’s copied',
  'aet.instructorCourse.courseForm.copyAccordionSubTitle': 'Copied data',
  'aet.studentRoster.manageStudentRosterButton': 'Manage student list',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.assignments.exportStudentProgressButton': 'Export student progress',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'Status:',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'Enrolled:',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'Role:',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': 'Promote  {studentName} ?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'As a teaching assistant, this person will be able to see the progress and performance of all students in this class.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'They will also be able to manage students and assignments, but they will not be able to delete the class.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'Promote to teaching assistant',
  'aet.home.manageRoster.searchPlaceholder': 'Search for student',
  'aet.home.manageRoster.inactivateButtonLabel': 'Deactivate selected students',
  'aet.home.manageRoster.FilterLabel': 'Show',
  'aet.home.manageRoster.updatingMessage': 'Updating student list... This may take a few minutes.',
  'aet.home.courses.search.searchPlaceHolder': 'Search your courses',
  'aet.courses.emptyStateDescription': 'Start building your course by choosing an option below.',
  'nativePromoBanner.continueInBrowser': 'Continue in browser',
  'globalnav.tooltip.hideNavText': 'Hide navigation',
  'globalnav.tooltip.showNavText': 'Show navigation',
  'aet.syllabus.progressTitle': 'Extracting...',
  'aet.syllabus.progressDesc': 'Please wait while we process your syllabus.',
  'aet.syllabus.uploadInputLabel': 'Drag and drop files or click to upload',
  'aet.syllabus.uploadSyllabusTabLabel': 'Upload syllabus',
  'aet.syllabus.dateAdjusterTabLabel': 'Date adjuster',
  'aet.syllabus.addManuallyTabLabel': 'Add manually',
  'aet.syllabus.addEditLaterText': 'You can always add and edit assignments later',
  'aet.syllabus.editAssignmentLabel': 'Edit assignment',
  'aet.syllabus.addAssignmentLabel': 'Add assignment',
  'aet.syllabus.assignmentTitleLabel': 'Assignment Title',
  'aet.syllabus.dueDateLabel': 'Due date',
  'aet.syllabus.editDueDateLabel': 'Edit due date',
  'aet.syllabus.chaptersCoveredLabel': 'Select the chapters or sections to cover.',
  'aet.syllabus.updateCtaLabel': 'Update assignment',
  'aet.syllabus.addCtaLabel': 'Add assignment',
  'aet.syllabus.uploadLabel': 'Upload',
  'aet.syllabus.confirmLabel': 'Confirm',
  'aet.syllabus.updateDatesLabel': 'Update date',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'Your due date was updated. Review it, then publish.',
  'aet.syllabus.coverageDedupe.adjustedContent': 'Your chapter/section information was updated. Review it, then publish.',
  'aet.syllabus.unassignedCoverageStatus': 'Some chapters are not assigned yet. Assign them before you publish.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.deleteAssignmentTitle': 'Delete assignment?',
  'aet.deleteAssignmentTitleMultiple': 'Delete assignments?',
  'aet.deleteAssignmentWarning': 'This action can\'t be undone, and all associated submissions and student data will no longer be visible.',
  'aet.deleteAssignmentKeepCTA': 'Keep assignment',
  'aet.deleteAssignmentDeleteCTA': 'Delete',
  'aet.assignments.loadingAsset': 'Loading asset...',
  'aet.assignments.allCaughtUpDescription': 'No assignments due this week.',
  'aet.assignments.progressTitle': 'Progress',
  'aet.assignments.performanceTitle': 'Performance',
  'aet.assignments.completionTitle': 'Completion',
  'aet.assignments.statusTitle': 'Status',
  'aet.assignments.addTooltip': 'Add assignment',
  'aet.assignments.deleteTooltip': 'Delete selected assignments',
  'aet.assignments.selectToDeleteLabel': 'Select and delete mode',
  'aet.assignments.bulkEditTooltip': 'Bulk edit assignments',
  'aet.assignments.title': 'Assignments',
  'aet.assignments.assignmentTitle': 'Assignment',
  'aet.assignments.dueDate': 'Due date',
  'aet.tabular.searchPlaceholder.assignments': 'Search assignments',
  'aet.tabular.searchPlaceholder.students': 'Search students',
  'aet.tabular.searchPlaceholder.questions': 'Search questions',
  'aet.assignemnts.columnDueDateInfoTooltip': 'One or more students have due date extensions for all assignments',
  'aet.assignemnts.singleDueDateInfoTooltip': ' One or more students have due date extensions for this assigment',
  'aet.assignemnts.masterDueDateInfoTooltip': 'One or more students have been granted due date extensions. Look for the info icon to identify these assignments.',
  'aet.home.loading': 'Loading...',
  'aet.home.errorFetchingAssignments': 'Error fetching assignments',
  'aet.home.dueThisWeekTitle': 'Due this week',
  'aet.home.allCaughtUpTitle': 'You\'re all caught up!',
  'aet.home.allCaughtUpDescription': 'No assignments due this week.',
  'aet.home.suggestedRemediationTitle': 'Suggested review by Study Prep',
  'aet.home.noSuggestedRemediationTitle': 'No suggested review material',
  'aet.home.noSuggestedRemediationDescription': 'Check back after your next assignment.',
  'aet.home.assignmentIncludesTitle': 'Assignment includes',
  'aet.home.sectionsLabel': 'Chapter(s)',
  'aet.home.questionsCount': '{count} questions',
  'aet.home.dueLabel': 'Due: {dueDate}',
  'aet.home.due': 'Due:',
  'aet.home.progressCompletedLabel': 'Completed',
  'aet.home.progressCompletedPastDueLabel': 'Completed past due',
  'aet.home.progressInProgressLabel': 'In progress',
  'aet.home.progressNotStartedLabel': 'Not started',
  'aet.home.progressCountOfTotal': '{count} of {total}',
  'aet.home.NotAttemptedLabel': 'Not attempted',
  'aet.home.questionsTotalLabel': 'Total questions',
  'aet.home.progressCompletedOnTimeLabel': 'Completed on time',
  'aet.home.segmentGreatLabel': 'Great',
  'aet.home.segmentGettingThereLabel': 'Okay',
  'aet.home.segmentNeedsReviewLabel': 'Needs work',
  'aet.home.segmentOkayLabel': 'Okay',
  'aet.home.editAssignmentTooltip': 'Edit assignment',
  'aet.home.deleteAssignmentTooltip': 'Delete assignment',
  'aet.home.viewDetailsButton': 'View details',
  'aet.home.viewAsStudentButton': 'View as student',
  'aet.home.welcomeButtonText': 'Get started →',
  'aet.review.emptyStateTitle': 'Nothing to review',
  'aet.review.emptyStateDescription': 'Check back after your next assignment.',
  'aet.dashboard.tabs.upNext': 'Up next',
  'aet.dashboard.tabs.welcome': 'Welcome',
  'aet.dashboard.tabs.assignments': 'Assignments',
  'aet.dashboard.tabs.review': 'Review',
  'aet.dashboard.tabs.studentRoster': 'Students',
  'aet.dashboard.classSchedule': 'Class schedule:',
  'aet.syllabus.dueTimeLabel': 'Due time',
  'hero.accessEducatorGuides': 'Access educator guides',
  'aet.assignment.save': 'Save',
  'aet.assignment.saveAndAdd': 'Save and add another',
  'aet.assignment.delete': 'Delete',
  'aet.assignment.saveAndClose': 'Save and close',
  'aet.studentRoster.title': 'Students',
  'aet.studentRoster.titlev1': 'Student',
  'aet.studentRoster.dueDatesAdjustmentLabel': 'Due dates',
  'aet.studentRoster.dueDateAdjustment.option.0': 'Standard',
  'aet.studentRoster.dueDateAdjustment.option.2': '+2 days',
  'aet.studentRoster.dueDateAdjustment.option.3': '+3 days',
  'aet.studentRoster.dueDateAdjustment.option.5': '+5 days',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '+1 week',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '+2 weeks',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': 'Last day of class',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count} assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': 'Past due assignments couldn\'t be updated automatically. Edit each one to set a new due date.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': 'Unable to update due dates',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'All assignments are due in the past and can\'t be updated automatically. Edit each one to set a new due date.',
  'aet.bulkEdit.bulkSplitInstruction': 'We will split your assignments up evenly.',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer. Editor library device auto star reesizing pencil horizontal. Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': 'First assignment due',
  'aet.bulkEdit.lastAssignmentDue': 'Last assignment due',
  'aet.bulkEdit.assignmentsDueDays': 'Which days would you like assignments to be due?',
  'aet.bulkEdit.addEditLaterText': 'We use AI to create assignments. You can always add and edit assignments later.',
  'aet.bulkEdit.monday': 'Monday',
  'aet.bulkEdit.tuesday': 'Tuesday',
  'aet.bulkEdit.wednesday': 'Wednesday',
  'aet.bulkEdit.thursday': 'Thursday',
  'aet.bulkEdit.friday': 'Friday',
  'aet.bulkEdit.saturday': 'Saturday',
  'aet.bulkEdit.sunday': 'Sunday',
  'aet.toast.assignmentCreated.title': 'Assignment created!',
  'aet.toast.assignmentCreated.single': 'It\'s been automatically named {assignmentTitle}',
  'aet.toast.assignmentCreated.multiple': '{count} assignments have been created',
  'aet.toast.assignmentUpdated.title': 'Updated successfully.',
  'aet.toast.assignmentUpdated.single': '{assignmentTitle} has been updated',
  'aet.toast.assignmentUpdated.multiple': '{count} assignments have been updated',
  'aet.toast.viewAssignment': 'View assignment',
  'aet.toast.viewAssignments': 'View assignments',
  'aet.welcome.title': 'Your Pearson eTextbook is now linked to your LMS course',
  'aet.welcome.LMSAccounTitle': 'Explore insights',
  'aet.welcome.LMSAccounDescription': 'See exactly which topics your class is struggling with.',
  'aet.welcome.createAssignmentsTitle': 'Create assignments',
  'aet.welcome.createAssignmentsDescription': 'Assign chapters manually or by uploading your syllabus.',
  'aet.welcome.progressViewTitle': 'Track performance in your LMS',
  'aet.welcome.progressViewDescription': 'Choose grade sync settings in your LMS course.',
  'aet.assignmentDetails.noAssignmentFound': 'No assignment found',
  'aet.assignments.loadingErrorTitle': 'Assignment can\'t be loaded right now',
  'aet.assignments.loadingErrorDescription': 'Try refreshing or check back later',
  'aet.assignmentStudentDetails.noDataFound': 'No data yet',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'No students registered',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'Students will join your class as they purchase the eTextbook.',
  'aet.home.editAssignmentTooltipDisabled': 'Cannot edit: student work in progress',
  'aet.home.deleteAssignmentTooltipDisabled': 'Cannot delete: student work in progress',
  'aet.home.StudentDetails.questions': 'Questions',
  'aet.home.StudentDetails.attempts': 'Attempts',
  'aet.home.StudentDetails.comprehension': 'Performance',
  'hero.titleInfo.tooltip': 'Title information',
  'aet.home.publishAssignments': 'Publish all assignments',
  'aet.dashboard.footer': 'Some content created using AI based on Pearson learning materials. While Pearson has a process to validate the output, generative AI may still produce inaccurate information about people, places, or facts.',
  'aet.home.bulkEditTitle': 'Edit assignments in bulk',
  'aet.home.bulkEditSubtitle': 'Make your changes to your syllabus, then re-upload it here. Your assignments and due dates will be updated to match.',
  'aet.home.createAssignmentTitle': 'Create assignments',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'Included in another assignment',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'Some sections are included in another assignment',
  'aet.welcome.welcome.Title': 'Welcome!',
  'aet.home.student.roaster.ProgressTitle': 'Total completion',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'Check back once students start the assignment.',
  'aet.home.whatDueThisWeekTitle': 'Here\'s what\'s due this week',
  'aet.assignments.edit.errorTitle': '{count} assignments have errors',
  'aet.assignments.edit.errorSubTitle': 'Assignments with errors can\'t be published. Edit them, or publish without them.',
  'aet.assignments.edit.publishAnyway': 'Publish anyway',
  'aet.assignments.edit.editAssignments': 'Edit assignments',
  'aet.assignments.edit.validationInfoToolTip': 'Edit assignment to remove errors',
  'aet.assignments.error.assignmentCreated.title': 'All assignments have errors',
  'aet.assignments.error.assignmentCreated.description': 'Assignments with errors can\'t be published. Edit them, or try a different syllabus.',
  'aet.assignments.error.uploadSyllabus': 'Upload syllabus',
  'aet.assignments.error.editAssignments': 'Edit assignments',
  'aet.mondly.title': 'Languages',
  'aet.studentRoster.errorState.title': 'Student list unavailable',
  'aet.studentRoster.errorState.description': 'We couldn\'t load your student list. Try refreshing or check back later.',
  'aet.assignments.sectionLabel': 'section(s)',
  'aet.assignments.questionsLabel': 'question(s)',
  'aet.assignments.assignmentsLabel': 'assignment(s)',
  'aet.assignments.performanceProgressBar': 'Performance Progress Bar',
  'aet.assignments.completionProgressBar': 'Completion Progress Bar',
  'aet.syllabus.deleteConfirmationSubtitleSingle': 'Are you sure you want to delete this assignment?',
  'aet.syllabus.deleteConfirmationSubtitleBulk': 'Are you sure you want to delete these assignments?',
  'aet.home.nextAssignmentTitle': 'Next assignment',
  'aet.home.courseSettings': 'Course settings',
  'aet.home.pearsonETextbookResources': 'Pearson+ eTextbook resources',
  'aet.home.etextbookInformation': 'eTextbook information',
  'aet.multiple.deleteAssignmentKeepCTA': 'Keep assignment(s)',
  'aet.syllabus.processingText.header': 'We are organising your class\'s assigned readings – this will only take a moment.',
  'aet.syllabus.processingText.uploading': 'Uploading your document',
  'aet.syllabus.processingText.activating': 'Activating AI components',
  'aet.syllabus.processingText.extracting': 'Extracting reading assignments',
  'aet.syllabus.processingText.mapping': 'Mapping to textbook content',
  'aet.syllabus.processingText.finishing': 'Finishing off',
  'aet.syllabus.uploadErrorMessage': 'Make sure your PDF or .docx is under 10MB and that your internet connection is stable',
  'aet.syllabus.uploadNoAssignmentsMessage': 'No reading assignments found',
  'aet.syllabus.uploadNoAssignmentsDescription': 'We could not pull reading assignments from this file. You can add them manually.',
  'aet.syllabus.uploadFailedRetryCTA': 'Try again',
  'aet.syllabus.selectChapterWithQuestions': 'Select a chapter with question(s).',
  'preferenceSetting.subTitle': 'These settings will be the default for all students in this course.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'AI interactions',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'Enable AI Study Tool and AI summaries in search results',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'Show Study Prep resources related to this book',
  'aet.syllabus.footer': 'Assignment creation is powered by AI',
  'aet.dashboard.footerDialogDeatils': 'Generative AI is used to create assignment questions based on Pearson learning  materials. While Pearson has a process to validate the output, generative AI may still produce inaccurate information about people, places, or facts. AI is also used to group content into assignments, based on the syllabus and/or schedule you provide.',
  'aet.review.footer': 'Created using AI',
  'aet.footerCard.dismiss': 'Dismiss',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'Study Prep is an additional tool that supports learning by providing students with videos and practice problems tailored to this course.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'Students whose access plan does not include Study Prep may be asked to subscribe in order to continue using Study Prep resources.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'Students who have already purchased Study Prep won’t be affected by this setting.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'Learn more about the benefits of Study Prep',
  'aet.home.viewCourseId': 'View course ID',
  'aet.home.copy': 'Copy',
  'aet.home.copied': 'Copied',
  'aet.home.courseLabel': 'Course ID:',
  'schoolInfoCard.addUniversity': 'Add school',
  'schoolInfoCard.title': 'School information',
  'schoolInfoCard.titleV1': 'Tell us about your course',
  'schoolInfoCard.cta': 'Get started',
  'schoolInfoCard.pickInstitution': 'Pick school',
  'schoolInfoCard.addUniversityTitle': 'Add your school',
  'schoolInfoCard.addUniversitySubtitle': 'Knowing your school and course helps us recommend the most useful study materials.',
  'schoolInfoCard.searchPlaceholder': 'Search for your school...',
  'schoolInfoCard.skip': 'Skip this step',
  'schoolInfoCard.nextStep': 'Next step',
  'schoolInfoCard.notInList': 'My school is not in the list',
  'schoolInfoCard.noResults': 'No schools found matching your search',
  'schoolInfoCard.noResultsHeading': 'Can\'t find your school?',
  'schoolInfoCard.noResultsInstruction': 'Enter the full name below',
  'schoolInfoCard.noResultsInputPlaceholder': 'School name',
  'schoolInfoCard.addInstitutionLabel': 'Add this school',
  'aet.assignments.assignmentTitlePlaceholder': 'Enter a title',
  'aet.assignments.titleValidation.titleRequired': 'Assignment title is required.',
  'aet.assignments.titleValidation.titleTooLong': 'Assignment title cannot exceed {0} characters.',
  'aet.assignments.titleValidation.titleInvalidChar': 'Assignment title contains unsupported characters.',
  'aet.assignments.titleValidation.titleDuplicate': 'Assignment title already exists',
  'aet.syllabus.timeZoneLabel': 'Time zone',
  'aet.review.reviewReadingFromAssignments': 'Review reading from assignment',
  'aet.assignments.chaptersLabel': 'chapter(s)',
  'menu.myAccount.subTitle': 'Your institution is found here',
  'menu.myAccount.subTitleNotAvailable': 'You can add the institution here later at any time.',
  'schoolInfoCard.toastMessage': 'University saved',
  'aet.review.threeDotMenu.askAI': 'Ask AI',
  'aet.home.suggestedRemediationSubtitle': 'Watch relevant videos and practise to master your course topics.',
  'aet.home.laggedQuestionLabel': 'Flagged questions',
  'aet.home.correctAnswer': 'Correct answer',
  'aet.home.incorrectAnswer': 'Most common incorrect answer',
  'aet.home.behaviourTrendsLabel': 'Question insights',
  'aet.home.strugglingStudentsLabel': 'Struggling students',
  'aet.home.patternsInStudensAiLabel': 'Patterns in student AI use',
  'aet.home.questionLabel': 'Question',
  'aet.home.studentAskingSimilarQuestions': 'Students asking similar questions',
  'aet.home.assignmentDifficultQuestions': 'Difficult questions',
  'aet.home.behaviorTrends': 'Question insights',
  'aet.home.behaviors': 'Performance indicators',
  'aet.home.mostDifficultTopics': 'Most difficult questions',
  'aet.home.commentsFromStudentLabel': 'Comments from students',
  'aet.home.disregard': 'Disregard',
  'aet.home.reportAsInaccurate': 'Report as inaccurate',
  'aet.home.Flagged': 'Flagged',
  'aet.home.reportQuestionTitle': 'Report question',
  'aet.home.reportQuestionLabel': 'What was wrong with this question?',
  'aet.home.showComments': 'Show comments',
  'aet.home.studentReports': 'student reports',
  'aet.home.placeholderText': 'Please explain...',
  'aet.home.reportQuestion.notRelevant': 'Not relevant',
  'aet.home.reportQuestion.notCorrect': 'Not correct',
  'aet.home.reportQuestion.unsafe': 'Unsafe/Harmful',
  'aet.home.reportQuestion.somethingElse': 'Something else',
  'aet.home.StudentDetails.assistedByAI': 'Assisted by AI',
  'aet.home.strugglingStudents.emptyStateTitle': 'No students are struggling right now',
  'aet.home.strugglingStudents.emptyStateDescription': 'Check back later.',
  'aet.home.overallStatus.excelling': 'Excelling',
  'aet.home.overallStatus.fallingBehind': 'Falling behind',
  'aet.home.overallStatus.keepingUp': 'Keeping up',
  'aet.home.showOnlyDifficultQuestionsLabel': 'Show only “difficult questions"',
  'aet.home.showOnlyStrugglingStudentsLabel': 'Show only “struggling students"',
  'aet.home.viewQuestionInAssignment': 'View question in assignment',
  'aet.home.insightRisk.incorrectFirstAttempts': 'Incorrect first attempts',
  'aet.home.insightRisk.multipleIncorrectAttempts': 'Multiple incorrect attempts',
  'aet.home.insightRisk.lowConfidence': 'Low confidence',
  'aet.home.insightRisk.mediumConfidence': 'Medium confidence',
  'aet.home.insightRisk.lowEngagement': 'Low engagement',
  'aet.home.insightRisk.countOfStudents': '{count} of {total} students',
  'aet.home.insightRisk.na': 'N/A',
  'aet.home.strugglingStudentsHereLabel': 'Students struggling here',
  'aet.home.insightRisk.didNotAttempt': 'Did not attempt',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText'
};

export default engb;
